import {
  ViewContainerRef,
  ComponentRef,
  Injector,
  Injectable,
}from '@angular/core';
import { Importer, LazyLoaderService }from 'lazy-loader-service';

export interface RealextraOptions {
  unit: string;
  xname?: string;
  yname?: string;
  location?: string;
}
export interface RealchartData {
  data: any;
  options: RealextraOptions;
}
@Injectable({
  providedIn: 'root',
})
export class RealChartMakerStrategyService {
  private static chartRepo = new Map<string, () => Promise<any>>();
  constructor(private lazyLoaderService: LazyLoaderService) {}
  static setStrategy(key: string, importer: () => Promise<any>) {
    this.chartRepo.set(key, importer);
  }
  static getStrategy(key) {
    return this.chartRepo.get(key);
  }
  executeStrategy(
    container: ViewContainerRef,
    key: string,
    injector: Injector,
  ): Promise<ComponentRef<any>> {
    try {
      return this.lazyLoaderService.loadModuleInViewContainerRef(
        {
          loader: RealChartMakerStrategyService.getStrategy(key),
        } as Importer<any>,
        container,
        injector,
      );
    } catch (e) {}
  }
}
